<template>
  <div class="w-100" style="height: 92%">
    <div>
      <a-menu
        mode="horizontal"
        :default-selected-keys="['/equipment/view/monitor']"
        @click="clickMenuItem"
      >
        <a-menu-item key="/equipment/view/monitor">设备监测</a-menu-item>
        <a-menu-item key="/equipment/view/statistics">统计</a-menu-item>
        <a-menu-item key="/equipment/view/warning">预警设置</a-menu-item>
      </a-menu>
    </div>
    <div class="w-100 h-100">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clickMenuItem ({ key }) {
      this.$router.push({ path: key, query: this.$route.query })
    }
  }
}
</script>

<style>

</style>
